import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import { ContractModel } from "../contracts/contractModel";
import { CardModel } from "../contracts/cardModel";
import { CardLimit } from "../../data/cardLimits";

/** Модель ссмены пароля */
export class CardLimitsModel extends OperationModel {

  public cardId: number | null = null;

  public cardLimits: Array<CardLimit> = [];

  public selectedLimit : CardLimit | null = null;
    
  constructor(cardId: number) {
    super();
    this.cardId = cardId ?? null;
    this.Caption = i18n.t(`main.cards.actions.setLimitsTitle`).toString()
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;

    // ord.setProperty("type", this.type, DeclarationPropertiesTypes.String);

    if(this.selectedLimit) {
      ord.setProperty(
        "card",
        this.selectedLimit.cardRefId,
        DeclarationPropertiesTypes.String
      );
      ord.setProperty(
        "Period",
        this.selectedLimit.Period,
        DeclarationPropertiesTypes.Int
      );
      ord.setProperty(
        "SummaCode",
        this.selectedLimit.SummaCode,
        DeclarationPropertiesTypes.String
      );

      const summaValue = this.selectedLimit.dayLimit.trim() !== ''
        ? this.selectedLimit.dayLimit.replace(/[^\d.,]/g, '').replace(',', '.')
        : null;
    
      // Добавляем Summa только если summaValue не null
      if (summaValue !== null) {
        ord.setProperty(
          "Summa",
          summaValue,
          DeclarationPropertiesTypes.String
        );
      }
    }

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }
}
